export const DEMO_EMAIL =
  'mailto:brandon@evasive.ai?cc=jared@evasive.ai&subject=Evasive.ai%20Platform%20Access';
export const SUPPORT_EMAIL =
  'mailto:jared@evasive.ai?subject=Platform%20Support%20Request';
export const PATENT_URL = 'https://patents.google.com/patent/US12019746B1/en';
export const PATENT_NUMBER = 'US 12,019,746';

export const HEADLINE_TEXT =
  'Create evasive malware with nation-state capabilities—on demand.';
export const BODY_TEXT =
  "Born from U.S. national lab research supporting Department of War evaluations of EDR, NDR, and SOAR vendors, our Preemptive Malware Generator creates functional variants that evade today's static and behavioral detection defenses—giving defenders adversary-grade evasion on demand to expose blind spots before attackers exploit them.";

export const MAINTENANCE_HEADLINE = 'Scheduled Maintenance';
export const MAINTENANCE_BODY =
  'platform.evasive.ai and platform-api.evasive.ai are temporarily unavailable while we perform maintenance. We apologize for the interruption and will restore access as soon as we can.';
